import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE = 'identity';

const IdentityService = {
  getAll() {
    return Http.get(`/${RESOURCE}/list`);
  },
  getById(id) {
    return Http.get(`/${RESOURCE}/${id}`)
  },
  getInitFormData() {
    return {
      companyName: "",
      contactName: "",
      email: '',
      logoFile: null,
      telephone: '',
      address: '',
      codePostal: '',
      city: '',
      countryId: '',
      description: '',
      isActive: 0
    }
  },
  create(data) {
    const formData = ApiUtil.objectToFormData(data);

    return Http.post(`/${RESOURCE}`, formData);
  },
  update(id, data) {
    const formData = ApiUtil.objectToFormData(data);

    return Http.post(`/${RESOURCE}/${id}`, formData);
  },
  delete(id) {
    return Http.delete(`/${RESOURCE}/${id}`);
  },
  setDefault(id) {
    return Http.post(`/${RESOURCE}/is-default/${id}`);
  }
};

export default IdentityService;
